import { createFrontendModule } from "@backstage/frontend-plugin-api";

import { argocdContent } from "./argocd";
import { jiraContent, jiraOverviewCard } from "./jira";
import {
    apisContent,
    dependenciesContent,
    subcomponentsContent,
} from "./relationships";
import { templateInsightsContent } from "./templateInsights";

const catalogModuleEntityPages = createFrontendModule({
    pluginId: "catalog",
    extensions: [
        argocdContent,
        jiraOverviewCard,
        jiraContent,
        apisContent,
        subcomponentsContent,
        dependenciesContent,
        templateInsightsContent,
    ],
});

export default catalogModuleEntityPages;
